export default __webpack_public_path__ + "ui/assets/img/arrow-up-white-32.svg";